import {useContext, useEffect, useState} from 'react';
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Button,
    ModalBody,
    Form,
    Label,
    Input,
    Modal, ModalHeader, FormGroup, FormFeedback
} from "reactstrap";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import Loader from "../../components/Loader";
import handleUnauthorized401MutateError from "../../utils/handleUnauthorized401MutateError";
import AuthContext from "../../context/AuthContext";
import {
    addOnProductStockUpdate, changeAddOnProductInventoryTrackingStatus,
    changeAddOnProductStatus,
    editAddOnProduct, getProducts,
} from "../../api/api";
import Select from "react-select";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import AddOnProductStockModal from "./AddOnProductStockModal";


function ActionButton(props) {
    const {refreshToken} = useContext(AuthContext)
    const [actionButtonDropdownOpen, setActionButtonDropdownOpen] = useState(false);
    const toggleActionButtonDropdown = () => {
        setActionButtonDropdownOpen(prevState => {
            const newDropdownState = !prevState;
            document.querySelector('.table-responsive').classList.toggle('dropdown-open', newDropdownState);
            return newDropdownState;
        });
    }
    const [addOnProductUpdateToggle, setAddOnProductUpdateToggle] = useState(false);
    const toggleAddOnProductUpdateModal = () => {
        setAddOnProductUpdateToggle(prevState => {
            const newState = !prevState;
            if (!newState) resetFormFields();
            return newState;
        });
    };
    const [addOnProductStockUpdateToggle, setAddOnProductStockUpdateToggle] = useState(false);
    const toggleAddOnProductStockUpdateModal = () =>
        setAddOnProductStockUpdateToggle((prevState) => !prevState);
    // const [addOnProductSettingsToggle, setAddOnProductSettingsToggle] = useState(false);
    // const toggleAddOnProductSettingsModal = () =>
    //     setAddOnProductSettingsToggle((prevState) => !prevState);
    const [addOnProductName, setAddOnProductName] = useState(props.addOnProduct.name);
    const [addOnProductPrice, setAddOnProductPrice] = useState(props.addOnProduct.price);
    const [addOnProductUPC, setAddOnProductUPC] = useState(props.addOnProduct.upc);
    // const [addOnProductTaxType, setAddOnProductTaxType] = useState(props.addOnProduct.tax_type);
    // const [addOnProductTaxPercentage, setAddOnProductTaxPercentage] = useState(props.addOnProduct.tax_percentage);
    const [addOnProductDescription, setAddOnProductDescription] = useState(props.addOnProduct.description);
    const [addOnProductImage, setAddOnProductImage] = useState('');
    const [addOnProductStockTransactionName, setAddOnProductStockTransactionName] = useState('');
    const [addOnProductStock, setAddOnProductStock] = useState('');
    const [addOnProductStockTransactionType, setAddOnProductStockTransactionType] = useState('CR');
    const [productOptions, setProductOptions] = useState([]);
    const [addOnProductRecords, setAddOnProductRecords] = useState(1);
    const [productsSupported, setProductsSupported] = useState(props.addOnProduct.products.map(product => product.name));
    const [currentProductsSupported, setCurrentProductsSupported] = useState([]);
    const [advancedOptions, setAdvancedOptions] = useState(false);
    const [addOnProductStockHistoryModal, setAddOnProductStockHistoryModal] = useState(false);
    const addOnProductStockHistoryModaltoggle = () => setAddOnProductStockHistoryModal(!addOnProductStockHistoryModal);

    const resetFormFields = () => {
        setAddOnProductName(props.addOnProduct.name);
    };

    useEffect(() => {
        const currentDefault = props.addOnProduct.products.map((product) => ({
            value: product.name,
            label: product.name,
        }));
        setCurrentProductsSupported(currentDefault);
    }, [props.addOnProduct.products]);

    useEffect(() => {
        const validProducts = productsSupported.filter(product => product);
        const currentDefault = validProducts.map((product) => ({
            value: product,
            label: product,
        }));
        setCurrentProductsSupported(currentDefault);
    }, [productsSupported]);

    const onSelect = (selectedOptions) => {
        const selectedProducts = selectedOptions
            .map((option) => option.value)
            .filter((value) => value);
        setProductsSupported(selectedProducts);
    };

    const queryClient = useQueryClient()

    const { refetch } = useQuery({
        queryKey: ['products', addOnProductRecords],
        queryFn: () => getProducts(1,'', '','','', '', '','',
            '', '','', '', '', '', '', addOnProductRecords),
        keepPreviousData : true,
        retry: false,
        refetchOnWindowFocus: false,
        enabled: addOnProductUpdateToggle,
        onSuccess: (data =>{
            setAddOnProductRecords(data?.count)
            const newOptions = data.results
                .filter((product) => product.name)
                .map((product) => ({
                    value: product.name,
                    label: product.name,
                }));
            setProductOptions(newOptions);

            if (props.addOnProduct.products) {
                const initialProductsSupported = props.addOnProduct.products
                    .filter((product) => product.name) // Filter out products without names
                    .map((product) => product.name);
                setProductsSupported(initialProductsSupported);
            }
        }),
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        })
    })

    const changeAddOnProductStatusMutation = useMutation({
        mutationFn: changeAddOnProductStatus,
        onSuccess: () =>{
            queryClient.invalidateQueries(['add-on-products'])
            toast.success('Add-On Product Status Changed!')
        },
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, changeAddOnProductStatusMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })

    const changeAddOnProductInventoryTrackingStatusMutation = useMutation({
        mutationFn: changeAddOnProductInventoryTrackingStatus,
        onSuccess: () =>{
            queryClient.invalidateQueries(['add-on-products'])
            toast.success('Add On Product Inventory Status Changed!')
        },
        onError: (err,variables) => {
            handleUnauthorized401MutateError(err, refreshToken, changeAddOnProductStatusMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })

    const editAddOnProductMutation = useMutation({
        mutationFn: editAddOnProduct,
        onSuccess: (data) =>{
            toggleAddOnProductUpdateModal()
            queryClient.invalidateQueries(['add-on-products'])
            setProductsSupported(data.products.map(product => product.name));
            toast.success('Add-On Product updated!')
        },
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, editAddOnProductMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })

    const addOnProductStockUpdateMutation = useMutation({
        mutationFn: addOnProductStockUpdate,
        onSuccess: () =>{
            toggleAddOnProductStockUpdateModal()
            setAddOnProductStockTransactionName('')
            setAddOnProductStock('')
            setAddOnProductStockTransactionType('CR')
            queryClient.invalidateQueries(['add-on-products'])
            toast.success('Add-On Product Stock updated!')
        },
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, addOnProductStockUpdateMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })

    const handleChangeAddOnProductStatus = async (addOnProduct) => {
        let addOnProductStatus = {
            status: addOnProduct.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
        };
        changeAddOnProductStatusMutation.mutate({
            addOnProductStatus: addOnProductStatus, addOnProductId: addOnProduct.id
        })
    }

    const handleChangeAddOnProductInventoryTrackingStatus = async (addOnProduct) => {
        let addOnProductInventoryTrackingStatus = {
            is_inventory_tracking_enabled: addOnProduct.is_inventory_tracking_enabled !== true,
        };
        changeAddOnProductInventoryTrackingStatusMutation.mutate({
            addOnProductInventoryTrackingStatus: addOnProductInventoryTrackingStatus, addOnProductId: addOnProduct.id
        })
    }

    const handleEditAddOnProduct = async (addOnProduct, e) => {
        e?.preventDefault();
        const formData = new FormData();
        formData.append("name", addOnProductName);
        formData.append("price", addOnProductPrice);
        formData.append("description", addOnProductDescription);
        formData.append("upc", addOnProductUPC);
        // formData.append("tax_type", addOnProductTaxType);
        // formData.append("tax_percentage", addOnProductTaxPercentage);

        if (addOnProductImage) formData.append("image", addOnProductImage);
        productsSupported.forEach(product => {formData.append("products", product)})
        editAddOnProductMutation.mutate({
            formData: formData, addOnProductId: addOnProduct.id
        }, )
    };

    const handleAddOnProductStockUpdate = async (addOnProduct, e) => {
        e?.preventDefault();
        const formData = new FormData();
        formData.append("name", addOnProductStockTransactionName);
        formData.append("add_on_product", addOnProduct.id);
        formData.append("stock", addOnProductStock);
        formData.append("type", addOnProductStockTransactionType);

        addOnProductStockUpdateMutation.mutate({
            formData: formData, addOnProductId: addOnProduct.id
        })
    }

    return (
        <td className="text-center">
            <Dropdown
                nav
                isOpen={actionButtonDropdownOpen}
                toggle={toggleActionButtonDropdown}
                className="btn-group dropdown"
            >
                <DropdownToggle
                    caret
                    className="arrow-none btn btn-light btn-sm"
                >
                    <i className="mdi mdi-dots-horizontal"/>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-right profile-dropdown">
                    <DropdownItem
                        className="dropdown-item"
                        onClick={toggleAddOnProductUpdateModal}
                    >
                        <i className="mdi mdi-pencil mr-2 text-muted font-18 vertical-middle"/>
                        <span>Edit Add On Product</span>
                    </DropdownItem>
                    <DropdownItem
                        className="dropdown-item"
                        onClick={() => handleChangeAddOnProductStatus(props.addOnProduct)}
                    >
                        <i className="mdi mdi-cancel mr-2 text-muted font-18 vertical-middle"/>
                        <span>
                                {props.addOnProduct.status === "ACTIVE"
                                    ? "Make INACTIVE"
                                    : "Make ACTIVE"}
                            </span>
                    </DropdownItem>
                    <DropdownItem
                        className="dropdown-item"
                        onClick={() => handleChangeAddOnProductInventoryTrackingStatus(props.addOnProduct)}
                    >
                        <i className="mdi mdi-stocking mr-2 text-muted font-18 vertical-middle"/>
                        <span>
                                {props.addOnProduct.is_inventory_tracking_enabled === true
                                    ? "Disable Inventory Tracking"
                                    : "Enable Inventory Tracking"}

                            </span>
                    </DropdownItem>
                    {props.addOnProduct.is_inventory_tracking_enabled && (
                        <DropdownItem
                            className="dropdown-item"
                            onClick={toggleAddOnProductStockUpdateModal}
                        >
                            <i className="mdi mdi-update mr-2 text-muted font-18 vertical-middle"/>
                            <span>Update Stock</span>
                        </DropdownItem>
                    )}
                    {props.addOnProduct.is_inventory_tracking_enabled && (
                        <DropdownItem
                            className="dropdown-item"
                            onClick={addOnProductStockHistoryModaltoggle}
                        >
                            <i className="fe-box mr-2 text-muted font-18 vertical-middle"/>
                            <span>View Stock</span>
                        </DropdownItem>
                    )}
                </DropdownMenu>
            </Dropdown>
            <AddOnProductStockModal addOnProduct={props.addOnProduct} modal={addOnProductStockHistoryModal}
                                    modalToggle={addOnProductStockHistoryModaltoggle}/>
            <Modal
                isOpen={addOnProductUpdateToggle}
                toggle={toggleAddOnProductUpdateModal}
                backdrop="static"
                keyboard={false}
            >
                <ModalHeader toggle={toggleAddOnProductUpdateModal} close={
                    <button className="close" onClick={toggleAddOnProductUpdateModal}>
                        &times;
                    </button>
                }>
                    Update Add-On Product: {props.addOnProduct.name}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={(e) => handleEditAddOnProduct(props.addOnProduct, e)}>
                        <FormGroup>
                            <Label for="Name">Name<span className="text-danger">*</span> </Label>
                            <Input
                                type="text"
                                name="name"
                                id="name"
                                placeholder="Add-On Product name"
                                defaultValue={props.addOnProduct.name}
                                onChange={(e) =>
                                    setAddOnProductName(e.target.value)
                                }
                                invalid={
                                    editAddOnProductMutation.isError &&
                                    editAddOnProductMutation.error.response.data.name
                                }
                            />
                            {editAddOnProductMutation.isError && editAddOnProductMutation.error.response.data.name && (
                                <FormFeedback invalid>
                                    {editAddOnProductMutation.error.response.data.name}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="products-supported">
                                Select The Products That Supports This Add-On
                                <span className="text-danger">*</span>
                            </Label>
                            <Select
                                key={props.addOnProduct.id}
                                options={productOptions}
                                isMulti
                                noOptionsMessage = {() => "No Product(s) found!"}
                                placeholder = "Select Products..."
                                onChange={onSelect}
                                value={currentProductsSupported}
                                required={true}
                                styles={{
                                    control: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            borderColor: "#495561",
                                            backgroundColor: "#414d59",
                                            color: "white",
                                            padding: "0.45 0.9",
                                            border: 'none',
                                            boxShadow: 'none'
                                        }
                                    ),
                                    menu: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            backgroundColor: "#414d59",
                                            color: "#a8b5c3"
                                        }
                                    ),
                                    input: (baseStyles) => (
                                        {
                                            ...baseStyles,
                                            color: "white"
                                        }
                                    )
                                }}

                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="add-on-product-price">Price<span className="text-danger">*</span> </Label>
                            <Input
                                type="text"
                                min="1"
                                step="any"
                                name="add-on-product-price"
                                id="add-on-product-price"
                                placeholder="Add-On Product Price"
                                defaultValue={props.addOnProduct.price}
                                onChange={(e) =>
                                    setAddOnProductPrice(e.target.value)
                                }
                                invalid={
                                    editAddOnProductMutation.isError &&
                                    editAddOnProductMutation.error.response.data.price
                                }
                            />
                            {editAddOnProductMutation.isError && editAddOnProductMutation.error.response.data.price && (
                                <FormFeedback invalid>
                                    {editAddOnProductMutation.error.response.data.price}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup className="form-group mb-3">
                            <div className="custom-control custom-checkbox">
                                <Input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="checkbox-advanced-options"
                                    checked={advancedOptions}
                                    onChange={() => setAdvancedOptions(!advancedOptions)}
                                />
                                <Label
                                    className="custom-control-label"
                                    for="checkbox-advanced-options"
                                >
                                    Advanced Options
                                </Label>
                            </div>
                        </FormGroup>
                        {advancedOptions&& (
                            <FormGroup>
                                <Label for="add-on-product-description">Description</Label>
                                <Input
                                    type="textarea"
                                    name="add-on-product-description"
                                    id="add-on-product-description"
                                    defaultValue={props.addOnProduct.description}
                                    onChange={(e) =>
                                        setAddOnProductDescription(e.target.value)
                                    }
                                    invalid={
                                        editAddOnProductMutation.isError &&
                                        editAddOnProductMutation.error.response.data.description
                                    }
                                />
                                {editAddOnProductMutation.isError && editAddOnProductMutation.error.response.data.description && (
                                    <FormFeedback invalid>
                                        {editAddOnProductMutation.error.response.data.description}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions&& (
                            <FormGroup>
                                <Label for="upc">UPC</Label>
                                <Input
                                    type="text"
                                    name="upc"
                                    id="upc"
                                    placeholder="Add On Product UPC"
                                    defaultValue={props.addOnProduct.upc}
                                    onChange={(e) =>
                                        setAddOnProductUPC(e.target.value)
                                    }
                                    invalid={
                                        editAddOnProductMutation.isError &&
                                        editAddOnProductMutation.error.response.data.upc
                                    }
                                />
                                {editAddOnProductMutation.isError && editAddOnProductMutation.error.response.data.upc && (
                                    <FormFeedback invalid>
                                        {editAddOnProductMutation.error.response.data.upc}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {/*{advancedOptions&& (*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label for="tax-type">Tax Type</Label>*/}
                        {/*        <Input*/}
                        {/*            type="select"*/}
                        {/*            name="add-on-product-tax-type"*/}
                        {/*            id="add-on-product-tax-type"*/}
                        {/*            className="form-control mb-2"*/}
                        {/*            placeholder="Add-On Product Tax-type"*/}
                        {/*            value={addOnProductTaxType}*/}
                        {/*            onChange={(e) => setAddOnProductTaxType(e.target.value)}*/}

                        {/*        ><option value="">--</option>*/}
                        {/*            <option value={"TAX-INCLUSIVE"}>*/}
                        {/*                Tax Inclusive*/}
                        {/*            </option>*/}
                        {/*            <option value={"TAX-EXCLUSIVE"}>*/}
                        {/*                Tax Exclusive*/}
                        {/*            </option>*/}
                        {/*        </Input>*/}
                        {/*            {editAddOnProductMutation.isError && editAddOnProductMutation.error.response.data.tax_type && (*/}
                        {/*                <FormFeedback invalid>*/}
                        {/*                    {editAddOnProductMutation.error.response.data.tax_type}*/}
                        {/*                </FormFeedback>*/}
                        {/*            )}*/}
                        {/*    </FormGroup>*/}
                        {/*)}*/}
                        {/*{advancedOptions&& (*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label for="tax-percentage">Tax Percentage</Label>*/}
                        {/*        <Input*/}
                        {/*            type="text"*/}
                        {/*            name="tax-percentage"*/}
                        {/*            id="tax-percentage"*/}
                        {/*            placeholder="Product Tax Percentage"*/}
                        {/*            defaultValue={props.addOnProduct.tax_percentage}*/}
                        {/*            onChange={(e) =>*/}
                        {/*                setAddOnProductTaxPercentage(e.target.value)*/}
                        {/*            }*/}
                        {/*            invalid={*/}
                        {/*                editAddOnProductMutation.isError &&*/}
                        {/*                editAddOnProductMutation.error.response.data.tax_percentage*/}
                        {/*            }*/}
                        {/*        />*/}
                        {/*        {editAddOnProductMutation.isError && editAddOnProductMutation.error.response.data.tax_percentage && (*/}
                        {/*            <FormFeedback invalid>*/}
                        {/*                {editAddOnProductMutation.error.response.data.tax_percentage}*/}
                        {/*            </FormFeedback>*/}
                        {/*        )}*/}
                        {/*    </FormGroup>*/}
                        {/*)}*/}
                        <FormGroup>
                            <Label for="add-on-product-image">Image</Label>
                            <Input
                                type="file"
                                name="add-on-product-image"
                                id="add-on-product-image"
                                // value={props.addOnProduct.image}
                                onChange={(e) =>
                                    setAddOnProductImage(e.target.files[0])
                                }
                                invalid={
                                    editAddOnProductMutation.isError &&
                                    editAddOnProductMutation.error.response.data.image
                                }
                            />
                            {editAddOnProductMutation.isError && editAddOnProductMutation.error.response.data.image && (
                                <FormFeedback invalid>
                                    {editAddOnProductMutation.error.response.data.image}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <Button
                            color="#4d5bed"
                            className="bx-btn-primary"
                            block
                            disabled={editAddOnProductMutation.isLoading}
                        >
                            {editAddOnProductMutation.isLoading? <><Loader size={'small'}/> Updating Add-On Product...</>: `Update Add-On Product`}
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={addOnProductStockUpdateToggle}
                toggle={toggleAddOnProductStockUpdateModal}
            >
                <ModalHeader toggle={toggleAddOnProductStockUpdateModal} close={
                    <button className="close" onClick={toggleAddOnProductStockUpdateModal}>
                        &times;
                    </button>}>
                    Update Add-On Product Stock: {props.addOnProduct.name}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={(e) => handleAddOnProductStockUpdate(props.addOnProduct, e)}>
                        <FormGroup>
                            <Label for="Name">Name</Label>
                            <Input
                                type="text"
                                name="add-on-product-stock-transaction-name"
                                id="add-on-product-stock-transaction-name"
                                placeholder="Add-On Product Stock Transaction Name"
                                // defaultValue={props.addOnProduct.name}
                                onChange={(e) =>
                                    setAddOnProductStockTransactionName(e.target.value)
                                }
                                invalid={
                                    addOnProductStockUpdateMutation.isError &&
                                    addOnProductStockUpdateMutation.error.response.data.name
                                }
                            />
                            {addOnProductStockUpdateMutation.isError && addOnProductStockUpdateMutation.error.response.data.name && (
                                <FormFeedback invalid>
                                    {addOnProductStockUpdateMutation.error.response.data.name}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="Stock">Stock<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                name="add-on-product-stock"
                                id="add-on-product-stock"
                                placeholder="Stock"
                                // defaultValue={props.addOnProduct.price}
                                onChange={(e) =>
                                    setAddOnProductStock(e.target.value)
                                }
                                invalid={
                                    addOnProductStockUpdateMutation.isError &&
                                    addOnProductStockUpdateMutation.error.response.data.stock
                                }
                            />
                            {addOnProductStockUpdateMutation.isError && addOnProductStockUpdateMutation.error.response.data.stock && (
                                <FormFeedback invalid>
                                    {addOnProductStockUpdateMutation.error.response.data.stock}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="type">Type<span className="text-danger">*</span></Label>
                            <Input
                                type="select"
                                name="select"
                                id="type"
                                className={"form-control"}
                                defaultValue={addOnProductStockTransactionType}
                                onChange={(e) =>
                                    setAddOnProductStockTransactionType(e.target.value)
                                }
                                invalid={
                                    addOnProductStockUpdateMutation.isError &&
                                    addOnProductStockUpdateMutation.error.response.data.type
                                }
                            >
                            <option value={'CR'}>
                                CREDIT
                            </option>
                            <option value={'DR'}>
                                DEBIT
                            </option>
                            </Input>
                            {addOnProductStockUpdateMutation.isError && addOnProductStockUpdateMutation.error.response.data.type && (
                                <FormFeedback invalid>
                                    {addOnProductStockUpdateMutation.error.response.data.type}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <Button
                            color="#4d5bed"
                            className="bx-btn-primary"
                            block
                            disabled={editAddOnProductMutation.isLoading}
                        >
                            {editAddOnProductMutation.isLoading? <><Loader size={'small'}/> Updating Add-On Product...</>: `Update Stock`}
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
            {/*<Modal*/}
            {/*    isOpen={addOnProductSettingsToggle}*/}
            {/*    toggle={toggleAddOnProductSettingsModal}*/}
            {/*>*/}
            {/*    <ModalHeader toggle={toggleAddOnProductSettingsModal}>*/}
            {/*        Add-On Product Settings: {props.addOnProduct.name}*/}
            {/*    </ModalHeader>*/}
            {/*</Modal>*/}
        </td>
    );
}

export default ActionButton;